const campaignSwiper = new Swiper('.campaign-swiper', {
    // Optional parameters
    loop: true,
    effect: 'slide',
    slidesPerView: 1.2,
    spaceBetween: 10,
    // Navigation (arrows)
    centeredSlides: true,
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      // スライドの表示枚数：600px以上の場合
      990: {
        slidesPerView: 1,
      },
    },
  });

  const kvSwiper = new Swiper('.kv-swiper', {
    // Optional parameters
    loop: true,
    effect: 'slide',
    slidesPerView: 1,
    spaceBetween: 10,
    // Navigation (arrows)
    navigation: {
        nextEl: '.kv-swiper-button-next',
        prevEl: '.kv-swiper-button-prev',
    },
    scrollbar: {
      el: '.swiper-scrollbar',
    },
  });

  const ideaSwiper = new Swiper('.p-top-idea__swiper', {
    // Optional parameters
    loop: true,
    effect: 'slide',
    slidesPerView: 1.8,
    spaceBetween: 15,
    // Navigation (arrows)
    navigation: {
        nextEl: '.idea-swiper-button-next',
        prevEl: '.idea-swiper-button-prev',
    },
    breakpoints: {
      // スライドの表示枚数：990px以上の場合
      990: {
        slidesPerView: 5,
        spaceBetween: 30,
      },
    },
  });


  const contentSwiper = new Swiper('.content-swiper', {
    // Optional parameters
    loop: true,
    effect: 'slide',
    slidesPerView: 2.5,
    spaceBetween: 15,
    breakpoints: {
      // スライドの表示枚数：600px以上の場合
      990: {
        slidesPerView: 5,
        spaceBetween: 30,
      },
    },



  });

  const cordinationSwiper = new Swiper('.cordination-swiper', {
    // Optional parameters
    loop: true,
    effect: 'slide',
    slidesPerView: 1,


    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },


    pagination: {
      el: ".cordination-swiper-pagination", // ページネーションのクラス名を指定
      //type: "fraction",  ページネーションのtypeを指定
      clickable: true, // ドットをクリック可能にする（おすすめ）
    },
    navigation: {
      nextEl: '.cordination-swiper-button-next',
      prevEl: '.cordination-swiper-button-prev',
    },
  });

  const cordinationspSwiper = new Swiper('.cordination-swiper-sp', {
    // Optional parameters
    loop: true,
    effect: 'slide',
    slidesPerView: 1,


    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },

    pagination: {
      el: ".cordination-swiper-pagination-sp", // ページネーションのクラス名を指定
      //type: "fraction",  ページネーションのtypeを指定
      clickable: true, // ドットをクリック可能にする（おすすめ）
    },
    navigation: {
      nextEl: '.cordination-swiper-button-next-sp',
      prevEl: '.cordination-swiper-button-prev-sp',
    },
  });


  const riimtypespSwiper = new Swiper('.room-type-swiper', {
    // Optional parameters
    loop: true,
    effect: 'slide',
    slidesPerView: 1.2,
    spaceBetween: 15,
  });


  const kvspSwiper = new Swiper('.kv-swiper-sp', {
    // Optional parameters
    loop: true,
    effect: 'slide',
    slidesPerView: 1,
    spaceBetween: 10,
    // Navigation (arrows)
    navigation: {
        nextEl: '.kv-swiper-sp-button-next',
        prevEl: '.kv-swiper-sp-button-prev',
    },
    scrollbar: {
      el: '.swiper-scrollbar-sp',
    },
  });


  const changecolorswiper = new Swiper('#changecolorswiper', {
    // Optional parameters
    loop: false,
    effect: 'fade',
    slidesPerView: 1,
    spaceBetween: 10,
    // Navigation (arrows)
    centeredSlides: true,
    pagination: {
      el: ".change-color-swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: '.color-swiper-button-next',
      prevEl: '.color-swiper-button-prev',
    },
  });


  const changeproductsswiper = new Swiper('#changeproductsswiper', {
    // Optional parameters
    loop: false,
    effect: 'slide',
    slidesPerView: 1,
    spaceBetween: 0,
    // Navigation (arrows)
    centeredSlides: true,
  });

  // 以下を追記
changecolorswiper.controller.control = [changeproductsswiper];
changeproductsswiper.controller.control = [changecolorswiper];



const products1Swiper = new Swiper('.c-products-slider__swiper1', {
  // Optional parameters
  loop: false,
  effect: 'slide',
  slidesPerView: 2.3,
  spaceBetween: 15,
  breakpoints: {
    // スライドの表示枚数：990px以上の場合
    990: {
      slidesPerView: 5,
      spaceBetween: 30,
    },
  },
});


const shopkvSwiper = new Swiper('.shop-kv-slider', {
  // Optional parameters
  loop: true,
  effect: 'slide',
  slidesPerView: 1,
  spaceBetween: 0,
  // Navigation (arrows)
  navigation: {
      nextEl: '.shop-kv-swiper-button-next',
      prevEl: '.shop-kv-swiper-button-prev',
  },
  pagination: {
    el: ".shop-kv-swiper-pagination",
    clickable: true,
  },
});

const collectionNavSWiper = new Swiper('.js-collection-nav-slider',{
  slidesPerView: 'auto',
  spaceBetween: 30,
  freeMode: true,
})



const mvSwiper2 = new Swiper('.mv-swiper', {
    loop:true,
    spaceBetween: 10,
    centeredSlides: true,
    //slidesPerView: 2.1,
    // アイテムの左右はみだし
    slidesPerView: 'auto',
    // If we need pagination
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    autoplay: {
      delay: 3000, // 5秒ごとにスライド
      disableOnInteraction: false,
    },
    navigation: { // 矢印ナビゲーションを追加
      nextEl: '.swiper-mv-button-next',
      prevEl: '.swiper-mv-button-prev',
    },
    breakpoints: {
      // スライドの表示枚数：679px以上の場合
        679: {
    spaceBetween: 10,
        }
      },
  });






// 商品詳細のアコーディオン
{
  $('.js-productDetail-info-detail').click(function () {
    $(this).toggleClass('is-active');
    $(this).next().slideToggle();
  });

  $('#three-d-view').click(function(){
    const isPC = $(window).width() > 768;
    const modalClass = isPC ? '.pc-product-accordion .three-d-view-modal' : '.sp-product-accordion .three-d-view-modal';
    const threeDViewModal = $(modalClass).filter(function() {
      // 表示されている要素を取得
      return $(this).is(':visible');
    });
    const header_offset = $('.header').height() + 50;
    $('html, body').animate({
      scrollTop: threeDViewModal.offset().top - header_offset
    }, 500);
    threeDViewModal.addClass('is-active');
    threeDViewModal.next().slideToggle();
  });

/*関連商品のアコーディオン
  $('.related-header__button').click(function(){
    $('.related-product-list').slideToggle();
  });
*/
}



/**
 * サンプル商品追加 モーダル
 *
 */
{
  // モーダルの表示
  $('.js-productDetail-sampleBtn').click(function () {
    $('.productDetail-modal-sample').addClass('is-active');
    $('.productDetail-modal-sample__overlay').addClass('is-active');
    if ($('body').css('overflow-y', 'auto')) {
      $('body').css('overflow-y', 'hidden');
    }
  });
  $('.productDetail-modal-sample__overlay, .js-productDetail-modal-sample-close').click(function () {
    closeSampleModal();
  });
  function closeSampleModal(){
		$('.productDetail-modal-sample').removeClass('is-active');
		$('.productDetail-modal-sample__overlay').removeClass('is-active');
		if ($('body').css('overflow-y', 'auto')) {
		} else {
			$('body').css('overflow-y', 'auto');
		}
	}

  const sampleCartButton = document.querySelectorAll('.js-addsamples');
  sampleCartButton.forEach(async function(button){
    button.addEventListener('click',async function(){
      const productId = button.dataset.productId;

      const spinner = button.querySelector('.loading__spinner');
      if(spinner){
        spinner.classList.remove('hidden');
      }


      let formData = {
        'items': [{
          'id': productId,
          'quantity': 1
          }]
        };
      const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      }).then(response => response.json()).then(data => {
        if(spinner){
          spinner.classList.add('hidden');
        }
        alert('商品をカートに追加しました');
        window.location.href = '/cart';

      }).catch(error => {
        console.error('エラーが発生しました:', error);
      });

    });
  });
}

/**
 * カラーチップ
 *
 */
{
  /*--------------------------------------------
	// カラーチップ
	--------------------------------------------*/
	var color_target ;
	var target_image;
	$('.js-variantcolor').mouseover(
		function(){
			if($(window).width() <= 768) return;

				color_target= $(this).attr('data-target');

				if($(this).closest('.card').length > 0){
					target_image = $(this).closest('.card').find('[data-variantorder="'+ color_target +'"]');

				}else{

					target_image = $(this).parent().parent().find('[data-variantorder="'+ color_target +'"]');
				}

				target_image.show();
				target_image.addClass('is-show');

		}).mouseout(function(){
			if($(window).width() <= 768) return;
			target_image.hide();
			target_image.removeClass('is-show');
		});

		$('.js-variantcolor').click(function(el){
			if($(window).width() > 768) return;

			const card = $(this).closest('.card-wrapper');

			color_target= $(this).attr('data-target');
			variant_url = $(this).attr('data-varianturl');

			if($(this).closest('.card').length > 0){
				target_image = $(this).closest('.card').find('[data-variantorder="'+ color_target +'"]');
			}else{
				target_image = $(this).parent().parent().find('[data-variantorder="'+ color_target +'"]');
			}

			card.find('.media img').each(function(){
				$(this).hide();
			});

			card.addClass('is-changeImg');
			target_image.show();
			target_image.addClass('is-show');

			card.find('a').attr('href',variant_url);

		});

}





//3d my room

	// 横スライド05/06
  $('.p-3d__area-cardImg').click(function () {
    var $cardSlide = $(this).next('.p-3d__area-cardSlide');
    if ($cardSlide.hasClass('is-active')) {
      $cardSlide.removeClass('is-active');
      $(this).nextAll('.p-3d__area-cardClose').removeClass('is-active');
    } else {
      $('.p-3d__area-cardSlide.is-active').removeClass('is-active');
      $('.p-3d__area-cardClose.is-active').removeClass('is-active');
      $cardSlide.addClass('is-active');
      $(this).nextAll('.p-3d__area-cardClose').addClass('is-active');
    }
});
$('.p-3d__area-cardClose').click(function () {
$('.p-3d__area-cardSlide').removeClass('is-active');
$('.p-3d__area-cardClose').removeClass('is-active');
});


const rankingSwiper = new Swiper('.enen-collection-ranking-swiper', {
  // Optional parameters
  slidesPerView: 'auto',
  spaceBetween: 10,
  slidesPerView: 2.5,
  freeMode: false,
  breakpoints: {
    768: {
      slidesPerView: 5,
      spaceBetween: 20,
    }
  }
});




  $(function(){
    $('.related-gradient-button').on('click', function() {
      $('.related-product-list').addClass('expanded');
    });
  });